import 'react-perfect-scrollbar/dist/css/styles.css';
import React, { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'components/GlobalStyles';
import 'mixins/chartjs';
import theme from 'theme';
import rPrivadas from 'routes';
import rPublicas from 'routesPublicas'
import { Router } from '@material-ui/icons';
import axios from './utils/axios';
import "./components/react-datepicker.css"; 

const App = () => {

  const [routes,setRoutes]=useState(localStorage.getItem('token')?[]:rPublicas)
  //const [routes,setRoutes]=useState(rPublicas)
  useEffect(()=>{
  if(localStorage.getItem('token'))
    {
      axios.get('Ruta/TraerRutas')
        .then(response=>setRoutes(rPrivadas(response.data)))
        .catch(error=>{
          console.error("error "+error);
          localStorage.clear();
          window.location.reload(true);
        }
      )
    }
  },[])
  const routing = useRoutes(routes);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}      
    </ThemeProvider>
  );
};

export default App;
